import * as React from 'react';

import { Typography } from '@material-ui/core';

import { formatMoeda } from '../../utils';

// NF-e(s) do descarrego: `nfes` é anexado pelo servidor na listagem (número e chave)
const NfeField = ({ record }) => {
  const nfes = record && record.nfes ? record.nfes : [];

  if (nfes.length === 0) return <Typography variant="body2">-</Typography>;

  return (
    <div>
      {nfes.map(({ chave, numero }) => (
        <Typography key={chave} variant="body2" style={{ fontWeight: 'bold' }}>
          {numero}
        </Typography>
      ))}
    </div>
  );
};

// linha expandida da lista: descarrego unitário (valor por tonelada) e chave de acesso completa
export const DetalhesExpand = ({ record }) => {
  const nfes = record && record.nfes ? record.nfes : [];

  return (
    <div>
      <Typography variant="body2">
        <b>Descarrego unitário: </b>
        {`${formatMoeda(record ? record.valor_unitario : 0)} / t`}
      </Typography>
      {nfes.length === 0 ? (
        <Typography variant="body2">Sem NF-e vinculada.</Typography>
      ) : (
        nfes.map(({ chave, numero, compra_numero: compraNumero }) => (
          <Typography key={chave} variant="body2">
            <b>{`NF-e ${numero} - Chave de acesso: `}</b>
            <span style={{ fontFamily: 'monospace' }}>{chave}</span>
            <b>{' - Compra: '}</b>
            {compraNumero ? `nº ${compraNumero}` : 'não cadastrada'}
          </Typography>
        ))
      )}
    </div>
  );
};

export default NfeField;
